export interface ProductTypeAdditionalProductCost {
  id: string;
  productTypeId: string;
  productTypeDescription: string;
  additionalProductCostId: string;
  additionalProductCostKey: string;
  additionalProductCostDescription: string;
  selected: boolean;
}
